// ===== GENESIS GROUP OF COMPANIES — central content =====

const IMG = {
  hero: "https://static.prod-images.emergentagent.com/jobs/1b4fcdb0-0947-474b-8ed2-68c3a6734c29/images/68ea83913cb55853d56fed3cc728c906e6354694464b9a73e9030f91b3fd7aa4.jpeg",
  ganesha: "https://static.prod-images.emergentagent.com/jobs/1b4fcdb0-0947-474b-8ed2-68c3a6734c29/images/5325defa7b0ecb86224b5021010682e2ae90a8cfaf77a5f99d56ec9b08bf4cf9.jpeg",
  cowProducts: "https://static.prod-images.emergentagent.com/jobs/1b4fcdb0-0947-474b-8ed2-68c3a6734c29/images/45bdc9e9ffd27ad19a884047d4677f42162e69b8edbec2706a826de705724e1b.jpeg",
  education: "https://static.prod-images.emergentagent.com/jobs/1b4fcdb0-0947-474b-8ed2-68c3a6734c29/images/986c36616e3ba9b117fc6d54268b71d25ec15f2a5ae09d636a282fed871a76f1.jpeg",
  agro: "https://static.prod-images.emergentagent.com/jobs/1b4fcdb0-0947-474b-8ed2-68c3a6734c29/images/0c106c0eddbc0103f360815eb08f56c252927cec14bf1a0c001287fb1910aa14.jpeg",
  green: "https://static.prod-images.emergentagent.com/jobs/1b4fcdb0-0947-474b-8ed2-68c3a6734c29/images/9e60c0ea44b9fa0b23090fd31340aeeacce2cc847851c7778c9fc47287ce9334.jpeg",
  ecommerce: "https://static.prod-images.emergentagent.com/jobs/1b4fcdb0-0947-474b-8ed2-68c3a6734c29/images/d83d45d6661aa632164b3b63baa1a66117f3d7e1493fc79d2ec93b3c43c26e8a.jpeg",
  entertainment: "https://static.prod-images.emergentagent.com/jobs/1b4fcdb0-0947-474b-8ed2-68c3a6734c29/images/a9c8aa376e8aa62815664ca468caba073bcb14eb148aadb345541f40fd87e283.jpeg",
  healthcare: "https://static.prod-images.emergentagent.com/jobs/1b4fcdb0-0947-474b-8ed2-68c3a6734c29/images/63d17f443f12e15988bfe3198943f8bd28dbce8fe1732f8969cb2ae79534abdc.jpeg",
  itvfx: "https://static.prod-images.emergentagent.com/jobs/1b4fcdb0-0947-474b-8ed2-68c3a6734c29/images/d701db7e9a6230d890ca9d69f5b84d94420911f2c357c23234f09856da99ce4b.jpeg",
  importExport: "https://images.unsplash.com/photo-1606185540834-d6e7483ee1a4?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  marketing: "https://images.unsplash.com/photo-1603201667141-5a2d4c673378?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  franchise: "https://images.unsplash.com/photo-1638262052640-82e94d64664a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  investor: "https://images.unsplash.com/photo-1758691736483-5f600b509962?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
};

export const BRAND = {
  name: "GENESIS GROUP",
  full: "Genesis Group of Companies",
  legal: "Genesis Business Infra Pvt Ltd",
  since: "1994",
  contactPerson: "Vishal Gupta",
  designation: "Managing Director",
  phone: "9499799598",
  phoneDisplay: "+91 94997 99598",
  whatsapp: "919499799598",
  email: "vishaljgupta@gmail.com",
  tagline: "From Villages to Global Markets – Genesis Creates Opportunities",
  taglines: [
    "GENESIS – From Village to Global",
    "We Build Businesses, Not Just Companies",
    "India's Loan Doctor & Agro Innovator",
  ],
  states: ["Gujarat", "Maharashtra", "Uttar Pradesh", "West Bengal"],
  mall: "GENESIS MALL",
  mallFull: "GENESIS MALL by GENESIS GROUP",
  businessCenter: "All-in-One Business Center",
  groupTagline: "One Group. Many Opportunities.",
  groupSub: "Business • Shopping • Affiliate • Growth",
  bharatTagline: "Rooted in Bharat. Connected to Opportunity.",
};

export const waLink = (text) =>
  `https://wa.me/${BRAND.whatsapp}?text=${encodeURIComponent(text || "Hi Genesis Group, I'd like to know more about your businesses.")}`;
export const telLink = `tel:+${BRAND.whatsapp}`;

export const HERO_SLIDES = [
  { img: IMG.hero, kicker: "Since 1994", title: "Building India's Multi-Sector Empire", sub: "From door-to-door marketing to a global multi-business powerhouse." },
  { img: IMG.agro, kicker: "Agro & Innovation", title: "Connecting Farmers to Global Markets", sub: "Dairy, organic products & India's leading cow dung innovation." },
  { img: IMG.green, kicker: "Green Future", title: "Powering a Sustainable Tomorrow", sub: "Solar, construction & land development at scale." },
  { img: IMG.education, kicker: "Empowering Youth", title: "From Classrooms to Careers", sub: "Coaching, vocational training, placements & internships." },
];

export const TRUST_BAR = [
  { value: "30+ Yrs", label: "Legacy since 1994" },
  { value: "4 States", label: "Gujarat · Maharashtra · UP · West Bengal" },
  { value: "10,000+", label: "Clients Served" },
  { value: "Loan Doctor", label: "India's Trusted Finance Brand" },
];

// ===== BUSINESS SEGMENTS =====
export const SEGMENTS = [
  {
    slug: "education", name: "Genesis Education", short: "Education", icon: "GraduationCap", accent: "blue", img: IMG.education,
    tagline: "From Classrooms to Careers",
    intro: "Empowering students and job-seekers with government-exam coaching, vocational skills, defense training and guaranteed placement support.",
    features: ["UPSC / GPSC & Govt Exam Coaching", "Vocational & Skill Training", "Placement Cell & Career Guidance", "Defense & Police Training"],
    highlights: [{ k: "50+", v: "Courses" }, { k: "20k+", v: "Students Trained" }, { k: "85%", v: "Placement Rate" }],
    ctas: [{ label: "Apply Now", action: "lead" }, { label: "Franchise a Center", action: "franchise" }, { label: "Join as Intern", action: "internship" }],
  },
  {
    slug: "finance", name: "Genesis Finance — Loan Doctor", short: "Finance (Loan Doctor)", icon: "Stethoscope", accent: "gold", img: IMG.hero,
    tagline: "Your Financial Doctor – We Cure Loan Problems",
    intro: "India's trusted Loan Doctor. Business loans, government subsidy projects, bankable project reports and insurance — we approve where others fail.",
    features: ["Business & Personal Loans", "Govt Subsidy Projects", "Bankable Project Reports", "Insurance & Loan Settlement"],
    highlights: [{ k: "₹500 Cr+", v: "Facilitated" }, { k: "92%", v: "Approval Rate" }, { k: "Low CIBIL", v: "Specialists" }],
    ctas: [{ label: "Apply Loan", action: "loan" }, { label: "Upload Documents", action: "login" }, { label: "Track Application", action: "login" }],
    isFinance: true,
  },
  {
    slug: "agro-dairy", name: "Agro, Dairy & Cow Dung Industry", short: "Agro & Cow Dung", icon: "Sprout", accent: "green", img: IMG.agro, star: true,
    tagline: "India's Leading Cow Dung Innovation Company",
    intro: "Our star vertical — commercial dairy, organic agriculture and a pioneering eco-industry turning cow dung into export-ready products.",
    features: ["Commercial Dairy Farming", "Organic Agriculture & Fertilizers", "Export-Ready Eco Products", "Farmer-to-Market Linkage"],
    products: [
      { name: "Cow Dung Ganesha Idols", img: IMG.ganesha, desc: "Eco-friendly, hand-crafted, water-soluble festive idols." },
      { name: "Dhoop & Hawan Samagri", img: IMG.cowProducts, desc: "Natural, fragrant pooja essentials." },
      { name: "Organic Fertilizers", img: IMG.agro, desc: "Chemical-free soil nutrition for better yields." },
      { name: "Cow Dung Paint", img: IMG.cowProducts, desc: "Natural, breathable, anti-bacterial wall paint." },
      { name: "Eco Fire Logs", img: IMG.cowProducts, desc: "Clean-burning, sustainable fuel logs." },
      { name: "Handmade Eco Products", img: IMG.ganesha, desc: "Diyas, décor & gifting made from cow dung." },
    ],
    models: ["White Label Manufacturing", "Franchise Units", "Export Partnerships", "Bulk & Distributor Supply"],
    highlights: [{ k: "6+", v: "Product Lines" }, { k: "Export", v: "Ready" }, { k: "Eco", v: "100% Natural" }],
    ctas: [{ label: "Become Distributor", action: "franchise" }, { label: "Start a Factory", action: "franchise" }, { label: "Bulk Order", action: "lead" }],
  },
  {
    slug: "ecommerce", name: "Genesis E-Commerce", short: "E-Commerce", icon: "ShoppingBag", accent: "blue", img: IMG.ecommerce,
    tagline: "One Platform. Every Opportunity.",
    intro: "A multi-vendor marketplace spanning B2B, B2C, C2C and MLM — connecting sellers, buyers and affiliates across India.",
    features: ["B2B / B2C / C2C / MLM Platform", "Multi-Vendor Marketplace", "Seller Onboarding & Logistics", "Affiliate & Reseller Network"],
    highlights: [{ k: "Multi", v: "Vendor" }, { k: "PAN India", v: "Reach" }, { k: "MLM", v: "Ready" }],
    ctas: [{ label: "Seller Registration", action: "lead" }, { label: "Buyer Portal", action: "lead" }, { label: "Affiliate Join", action: "register" }],
  },
  {
    slug: "green-energy", name: "Green Energy & Greenfracon", short: "Green Energy", icon: "Leaf", accent: "green", img: IMG.green,
    tagline: "Powering a Sustainable Tomorrow",
    intro: "Solar power projects, sustainable construction and strategic land development — building green infrastructure for the future.",
    features: ["Solar Power Projects", "Sustainable Construction", "Land Development & Township", "EV & Carbon Credit Advisory"],
    highlights: [{ k: "MW-scale", v: "Solar" }, { k: "Green", v: "Construction" }, { k: "Carbon", v: "Credits" }],
    ctas: [{ label: "Partner With Us", action: "lead" }, { label: "Invest in Projects", action: "investor" }],
  },
  {
    slug: "entertainment", name: "Entertainment & Media", short: "Entertainment", icon: "Clapperboard", accent: "gold", img: IMG.entertainment,
    tagline: "Stories That Move India",
    intro: "Film production, large-scale events and professional casting — a full-stack media house for the new India.",
    features: ["Film & Web Production", "Event Management", "Talent Casting & Management", "Brand Films & Ad Shoots"],
    highlights: [{ k: "Film", v: "Production" }, { k: "Live", v: "Events" }, { k: "Casting", v: "Studio" }],
    ctas: [{ label: "Collaborate", action: "lead" }, { label: "Casting Registration", action: "lead" }],
  },
  {
    slug: "healthcare", name: "Healthcare & Herbal", short: "Healthcare & Herbal", icon: "HeartPulse", accent: "green", img: IMG.healthcare,
    tagline: "Nature's Wellness, Delivered",
    intro: "A range of natural, ayurvedic and herbal wellness products crafted for modern, health-conscious families.",
    features: ["Ayurvedic Product Range", "Natural Wellness & Immunity", "Herbal Personal Care", "Distributor Network"],
    highlights: [{ k: "Ayurvedic", v: "Range" }, { k: "Natural", v: "Ingredients" }, { k: "Wellness", v: "First" }],
    ctas: [{ label: "Become Distributor", action: "franchise" }, { label: "Bulk Enquiry", action: "lead" }],
  },
  {
    slug: "import-export", name: "Import & Export", short: "Import Export", icon: "Ship", accent: "blue", img: IMG.importExport,
    tagline: "India to the World",
    intro: "Taking Indian agro and eco products to global markets, and bringing the world's best to India through a trusted trade network.",
    features: ["Agro Products Export", "Eco Products Export", "Global Trade Partnerships", "Logistics & Compliance"],
    highlights: [{ k: "Global", v: "Trade" }, { k: "Agro + Eco", v: "Export" }, { k: "Compliant", v: "Logistics" }],
    ctas: [{ label: "Export Enquiry", action: "lead" }, { label: "Become a Trade Partner", action: "franchise" }],
  },
  {
    slug: "marketing", name: "Marketing & Branding", short: "Marketing", icon: "Megaphone", accent: "gold", img: IMG.marketing,
    tagline: "Building Brands That Lead",
    intro: "Full-service digital marketing, branding, affiliate and influencer programs powering growth across the Genesis ecosystem and beyond.",
    features: ["Digital Marketing & SEO", "Branding & Creative", "Affiliate Marketing", "Influencer Programs"],
    highlights: [{ k: "360°", v: "Digital" }, { k: "Affiliate", v: "Network" }, { k: "Influencer", v: "Program" }],
    ctas: [{ label: "Grow My Brand", action: "lead" }, { label: "Join Affiliate", action: "register" }],
  },
  {
    slug: "it-vfx", name: "IT & VFX (Upcoming)", short: "IT & VFX", icon: "Cpu", accent: "blue", img: IMG.itvfx, upcoming: true,
    tagline: "The Future, Rendered",
    intro: "Our upcoming technology vertical — software, IT services and world-class VFX & animation studios for film and gaming.",
    features: ["Software & IT Services", "VFX & 3D Animation", "Gaming & AR/VR", "Product Engineering"],
    highlights: [{ k: "Software", v: "Services" }, { k: "VFX", v: "Studio" }, { k: "AR / VR", v: "Labs" }],
    ctas: [{ label: "Register Interest", action: "lead" }, { label: "Careers in Tech", action: "career" }],
  },
];

export const findSegment = (slug) => SEGMENTS.find((s) => s.slug === slug);

// ===== VISION / MISSION / ROADMAP =====
export const VISION = {
  vision: "To become the World's Trusted Brand by 2030 — connecting villages to global markets.",
  mission: "Economic and social upliftment of youth, farmers and society by building sustainable, multi-sector businesses.",
  financialVision: "A ₹1,25,000 Cr turnover vision — driven by year-on-year growth across every Genesis vertical.",
};

// 5-year year-on-year turnover roadmap (2028 → 2032)
export const ROADMAP = [
  { year: "2028", target: "₹5,000 Cr", note: "Consolidation & multi-state scale-up" },
  { year: "2029", target: "₹18,000 Cr", note: "Agro & eco-industry export expansion" },
  { year: "2030", target: "₹45,000 Cr", note: "E-commerce + green energy at scale" },
  { year: "2031", target: "₹85,000 Cr", note: "Global trade & IT/VFX launch" },
  { year: "2032", target: "₹1,25,000 Cr", note: "World's Trusted Brand — full ecosystem" },
];

// ===== FRANCHISE =====
export const FRANCHISE_PLANS = [
  { name: "Starter", investment: "₹2 – 5 Lakh", roi: "18–24%", period: "12–18 months", perks: ["Single-unit license", "Training & onboarding", "Marketing kit", "Regional support"], popular: false },
  { name: "Growth", investment: "₹5 – 15 Lakh", roi: "24–32%", period: "10–14 months", perks: ["Multi-product license", "Priority territory", "Dedicated manager", "Co-branded campaigns"], popular: true },
  { name: "Enterprise", investment: "₹15 Lakh+", roi: "30–40%", period: "8–12 months", perks: ["Manufacturing/factory unit", "Exclusive district rights", "Export enablement", "Full ops support"], popular: false },
];

export const FRANCHISE_SEGMENTS = ["Education Coaching Center", "Loan Consultant Partner", "Agro & Dairy Franchise", "Cow Dung Manufacturing Unit", "Healthcare & Herbal Distributor", "E-commerce Seller", "Green Energy Project", "Entertainment & Media", "Import & Export Partner", "Marketing & Branding", "IT & VFX (Upcoming)", "Other"];

// ===== INVESTOR =====
export const REVENUE_STREAMS = [
  { icon: "Landmark", title: "Financial Services", desc: "Loan facilitation fees, subsidy consulting & insurance." },
  { icon: "Sprout", title: "Agro & Eco Industry", desc: "Dairy, organic & cow-dung product manufacturing + exports." },
  { icon: "ShoppingBag", title: "E-commerce & MLM", desc: "Marketplace commissions & distribution network." },
  { icon: "Leaf", title: "Green Energy", desc: "Solar projects, construction & land development." },
  { icon: "GraduationCap", title: "Education", desc: "Course fees, franchise royalties & placements." },
  { icon: "Ship", title: "Import & Export", desc: "Global trade margins on agro & eco products." },
];

export const TESTIMONIALS = [
  { name: "Rajesh Mehta", role: "Franchise Partner, Surat", text: "Started a cow-dung products unit with Genesis. The training and export support turned my small setup into a thriving business.", rating: 5 },
  { name: "Anita Sharma", role: "Dairy Entrepreneur, Nashik", text: "From project report to NABARD subsidy — Genesis handled everything. My dairy is now profitable within a year.", rating: 5 },
  { name: "Vikram Singh", role: "Loan Client, Jaipur", text: "Rejected by 3 banks for low CIBIL. Loan Doctor got me ₹18 Lakh approved in a week. Genuinely life-changing.", rating: 5 },
  { name: "Priya Nair", role: "Investor, Kochi", text: "A rare Indian group operating across so many high-growth sectors. Their 2032 roadmap is ambitious and credible.", rating: 5 },
];

// ===== CAREERS / INTERNSHIP =====
export const CAREERS = [
  { role: "Sales & DSA Executive", type: "Full-time", location: "PAN India", desc: "Drive lead conversions across finance, agro & franchise with attractive incentives." },
  { role: "Trainer / Faculty (Education)", type: "Full-time", location: "Multiple Cities", desc: "Teach government-exam and vocational batches at Genesis Education centers." },
  { role: "Loan Consultant", type: "Full-time", location: "Gujarat / Maharashtra", desc: "Advise clients on loans, subsidies and project funding under the Loan Doctor brand." },
  { role: "Factory / Production Worker", type: "Full-time", location: "Gujarat", desc: "Join our cow-dung & eco-products manufacturing units." },
  { role: "Finance Internship (Students)", type: "Internship", location: "Remote / On-site", desc: "3–6 month program with certificate, live projects & stipend for college students." },
  { role: "Marketing Internship (Students)", type: "Internship", location: "Remote", desc: "Hands-on digital marketing & branding internship with mentorship." },
];

export const INTERNSHIP_PERKS = [
  { icon: "Award", title: "Certification", desc: "Recognised completion certificate for your resume." },
  { icon: "Rocket", title: "Live Projects", desc: "Work on real business projects across sectors." },
  { icon: "Wallet", title: "Stipend Opportunities", desc: "Performance-based stipends for top interns." },
  { icon: "Building2", title: "College Tie-Ups", desc: "Structured MoUs with colleges & universities." },
];

export const BLOG_TOPICS = ["Dairy Farming", "Government Schemes", "Business Ideas", "Loan Guidance", "Eco Industry", "Green Energy"];

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "Genesis Group", to: "/about" },
  { label: "Our Businesses", to: "/businesses" },
  { label: "Genesis Mall", to: "/mall" },
  { label: "Rural Connect", to: "/rural-connect" },
  { label: "Affiliate", to: "/opportunity" },
  { label: "Ranks & Rewards", to: "/ranks-rewards" },
  { label: "How It Works", to: "/how-it-works" },
  { label: "Contact", to: "/contact" },
];

// ===== All-in-One Business Center hub tiles =====
export const HUB_TILES = [
  { icon: "Store", t: "Business" }, { icon: "Wrench", t: "Services" }, { icon: "ShoppingBag", t: "Shopping" },
  { icon: "MapPin", t: "Local" }, { icon: "Users", t: "Affiliate" }, { icon: "Rocket", t: "Opportunity" },
  { icon: "Sprout", t: "Rural" }, { icon: "Smartphone", t: "Digital" }, { icon: "TrendingUp", t: "Growth" },
];

// ===== Rural Connect pillars =====
export const RURAL_PILLARS = [
  { icon: "Tractor", t: "Farmers & Agri", d: "Linking agricultural producers to wider markets." },
  { icon: "Hand", t: "Artisans & Craft", d: "Bringing local craftsmanship to more customers." },
  { icon: "Store", t: "Local Retailers", d: "Helping neighbourhood shops reach new demand." },
  { icon: "Building2", t: "MSMEs", d: "Supporting small enterprises with a modern platform." },
  { icon: "Truck", t: "Connectivity", d: "Better access, logistics and digital reach." },
  { icon: "GraduationCap", t: "Skills & Services", d: "Local services and skilling opportunities." },
];

export const ECOSYSTEM_FLOW = ["Genesis Group", "Business Verticals", "Genesis Mall", "Customers", "Business Associates", "Local + Rural Connect", "Growth"];

// ===== GENESIS BUSINESS NETWORK (affiliate) — compliant presentation =====
export const NETWORK_COMPLIANCE = "Eligibility and rewards are subject to the applicable Genesis Group plan, terms and conditions. Genesis Group does not promise or guarantee any income. All rank rewards require milestone verification and administrative approval before payout.";

export const NETWORK_STEPS = [
  { icon: "UserPlus", t: "Register", d: "Create your free Genesis account using your sponsor's referral code." },
  { icon: "Share2", t: "Refer", d: "Share your referral link and introduce people to the Genesis ecosystem." },
  { icon: "Users", t: "Build Your Team", d: "Grow your network as customers and business associates join under you." },
  { icon: "TrendingUp", t: "Progress Ranks", d: "Advance through Genesis ranks as your team and activity grow." },
  { icon: "Gift", t: "Earn Rewards", d: "Unlock rank rewards and commissions as per the applicable plan." },
  { icon: "Banknote", t: "Get Paid", d: "Request a payout — released only after administrative approval." },
];

export const RANK_STAGES = [
  { k: "START", d: "Join Genesis & set up your profile" },
  { k: "BUILD", d: "Refer & form your first team" },
  { k: "GROW", d: "Expand your network & activity" },
  { k: "ACHIEVE", d: "Reach top ranks & unlock rewards" },
];

// ===== LOAN DOCTOR (Finance sub-services) — retained =====
export const SERVICES = [
  { slug: "personal-loan", icon: "Wallet", title: "Personal Loan", tagline: "Instant funds for every need", hero: IMG.hero, desc: "Quick, collateral-free personal loans — approved even with an average credit profile.", points: ["₹50K–₹40L", "Minimal docs", "24–72 hr approval", "Up to 60 months"] },
  { slug: "business-loan", icon: "Briefcase", title: "Business Loan", tagline: "Fuel your growth", hero: IMG.hero, desc: "Working capital, machinery & MSME loans for traders, manufacturers and service businesses.", points: ["Up to ₹75L unsecured", "OD / CC limits", "GST-based approvals", "Balance transfer"] },
  { slug: "project-funding", icon: "Building2", title: "Project Funding", tagline: "Capital for big visions", hero: IMG.green, desc: "Debt & equity structuring for infrastructure, energy and manufacturing with bankable reports.", points: ["₹1 Cr–₹500 Cr+", "Bankable DPR", "Equity funding", "NBFC tie-ups"] },
  { slug: "subsidy-projects", icon: "BadgePercent", title: "Subsidy Projects", tagline: "Govt schemes made simple", hero: IMG.agro, desc: "PMEGP, NABARD, Mudra & state subsidy schemes with complete documentation & liaison.", points: ["PMEGP / Mudra", "Up to 35% subsidy", "Full file prep", "End-to-end liaison"] },
  { slug: "loan-settlement", icon: "Handshake", title: "Loan Settlement", tagline: "Break free from debt", hero: IMG.hero, desc: "Professional one-time settlement negotiation to reduce your outstanding legally.", points: ["OTS negotiation", "Reduce outstanding", "Harassment relief", "Credit rebuild"] },
  { slug: "low-cibil-loan", icon: "ShieldCheck", title: "Low CIBIL Loan", tagline: "We approve where others reject", hero: IMG.hero, desc: "Our specialty — rejected, low CIBIL, NPA or default cases structured for approval.", points: ["Low CIBIL / NPA", "File re-structuring", "Score support", "Alternate lenders"] },
  { slug: "insurance-services", icon: "HeartPulse", title: "Insurance Services", tagline: "Protect what matters", hero: IMG.healthcare, desc: "Life, health, term, motor & business insurance advisory with claim assistance.", points: ["Life & term", "Health floater", "Business cover", "Claim assistance"] },
];

export const LOAN_TYPES = SERVICES.map((s) => s.title);

export const PROCESS = [
  { step: "01", title: "Apply / Enquire", desc: "Fill a 60-second form or reach us on WhatsApp." },
  { step: "02", title: "Free Consultation", desc: "Our expert reviews your profile & suggests the best fit." },
  { step: "03", title: "File Structuring", desc: "We prepare & strengthen your documentation for approval." },
  { step: "04", title: "Approval & Disbursal", desc: "Get sanctioned and funds disbursed to your account." },
];
